import React from 'react';
import ReactDOM from 'react-dom/client';
import { initI18n } from '@tarifdata/i18n';
import { useSettingsStore } from './store/settingsStore';
import App from './App';
import './index.css';

(async () => {
  const lang = useSettingsStore.getState().language;
  await initI18n(lang);

  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
})();
